<loader-animation *ngIf="show" [config]="config" [template]="template" [isAPIBased]="isAPIBased"></loader-animation>
